module.exports = __webpack_public_path__ + "img/initialEle.340af4bd.svg";